module.exports = __webpack_public_path__ + "img/mpn_bg.8501d463.jpg";